export const themeswitchActions = {
    changeTheme,
}

function changeTheme(mode){
    return dispatch => {
        dispatch({ type: mode });
    }
}